$(function () {
    if($('.region-checkbox').prop('checked')){
        $('.user-group-form-group').hide();
    }else{
        $('.user-group-form-group').show();
    }
    $('.region-checkbox').click(function () {
        if($(this).prop('checked')){
            $('.user-group-form-group').hide();
        }else{
            $('.user-group-form-group').show();
        }
    })
});